export const INIT = 'SEARCH_INIT'
export const SET_SEARCH_STATE = 'SET_SEARCH_STATE'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_SEARCH_HIGHLIGHTED_INDEX = 'SET_SEARCH_HIGHLIGHTED_INDEX'
export const OPEN_SEARCH_MENU = 'OPEN_SEARCH_MENU'
export const CLOSE_SEARCH_MENU = 'CLOSE_SEARCH_MENU'
